import { render, staticRenderFns } from "./CopyNodes.vue?vue&type=template&id=482a9d8a&"
import script from "./CopyNodes.vue?vue&type=script&lang=js&"
export * from "./CopyNodes.vue?vue&type=script&lang=js&"
import style0 from "./CopyNodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports